import { defineStore } from 'pinia'
export const settingStore = defineStore({
    id: 'setting',
    state: () => ({
        "export": false,
        "lang": "id",
        "user": {},
    }),
    getters: {
        "getExport": (state) => {
            return state.export;
        },
        "getLang": (state) => {
            return state.lang;
        },
        "getUser": (state) => {
            return state.user;
        },
    },
    actions: {
        setExport(val) {
            this.export = val;
        },
        setLang(val) {
            this.lang = val;
        },
        setUser(val) {
            this.user = val;
        },
    },
})